import React from "react";

const fullPageLoader = () => {
  return (
    <div className="page_loader">
      <div className="pl_loader">
        <img
          alt=""
          src={process.env.REACT_APP_STATIC_URL + "/images/mirror_loader.gif"}
        />
      </div>
    </div>
  );
};

export default fullPageLoader;
